<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-4 d-flex align-items-center">
                <div class="content">
                    <p class="h2 font-weight-bold">{{ headline }}</p>
                </div>
            </div>
            <div class="col-lg-5">
                <div class="content">
                    <p class="size-18 mb-0" v-for="entry in listEntries">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10">
                            <polygon fill="#0090BA" fill-rule="evenodd" points="5.269 18 .258 12.988 1.756 11.489 5.269 14.979 12.763 8 14.262 9.499" transform="translate(0 -8)"/>
                        </svg>
                        <span class="ml-1">{{ entry.text }}</span>
                    </p>
                </div>
            </div>
            <div class="col-lg-3 d-flex align-items-center justify-content-end">
                <a :href="btnUrl" class="btn btn-secondary">
                  {{ btnText }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            headline : String,
            btnText : String,
            btnUrl: String,
            listEntries: Array
        }
    }
</script>
